<button class="btn btn-sm btn-outline-primary" (click)="resetImport()" data-toggle="modal" data-backdrop="true" show="false" data-target="#packageImporter" title="{{ 'Buttons.AddPackage' | translate }}"><i class="fas fa-box-open" style="font-size:1rem"></i></button>

<div id="packageImporter" modal class="modal" data-target="packageImporter" tabindex="-1" role="dialog" data-toggle="modal" aria-labelledby="modal" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" *ngIf="manage.logo != null">
      <div class="modal-header p-3">
        <div class="row w-100 justify-content-between align-items-center">
          <div class="col">
            <h5 class="modal-title">{{ 'Settings.Packages' | translate }}</h5>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-window-close red" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="modal-body p-3">
        <div class="row">
          <input id="importPackageOwnPackagesSearch" class="form-control col-6 ml-3 mb-3" type="text" name="packageSearch" [(ngModel)]="manage.searchString" (keyup)="manage.search()" value="" placeholder="{{ 'Standard.Search' | translate }}" *ngIf="manage.packageType == 'own' && !manage.packageId">
        </div>
        <!--Choose package type-->
        <div class="row firstPage" *ngIf="manage.packageType != 'own' && manage.packageType != 'library'">
          <div class="col-6 text-center">
            <div class="card packageType" (click)="manage.packageType = 'own'; getCompanyPackages()">
              <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ manage.logo }}" alt="Package image" class="card-img-top">
              <div class="d-flex justify-content-center align-items-center mt-3 mb-3">
                <h3 class="">{{ 'Packages.ImportFromOwnPackages' | translate }}</h3>
              </div>
            </div>
          </div>
          <div class="col-6 text-center">
            <div class="card packageType" (click)="manage.packageType = 'library';">
              <img src="https://jubloapi.azure-api.net/api/shared/attachments/84c59f2c-adac-459b-b4a5-0f64ff99119b" alt="Package image" class="card-img-top">
              <div class="d-flex justify-content-center align-items-center mt-3 mb-3">
                <h3 class="">{{ 'Packages.ImportFromPackageLibrary' | translate }}</h3>
              </div>
            </div>
          </div>
        </div>
        <!--Own packages-->
        <div class="ownPackageList" *ngIf="manage.packageType == 'own' && manage.data != null && !manage.packageId">
          <div class="row align-items-center packageCard cursor-pointer" *ngFor="let p of manage.data.slice(0,50)">
            <div class="col-2">
              <img class="list-image" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ p.image }}" alt="Package image"/>
            </div>
            <div class="col-6">
              <div><b># {{ p.packageNumber }} - {{p.name}}</b></div>
              <div>{{ p.category }}</div>
              <div>{{ p.skill }}</div>
            </div>
            <div class="col-3 text-center self-centered">
              <div>{{ priceFormatter(p.salesPrice) }}</div>
              <div><b>{{  priceFormatter(p.salesPrice * 1.25) }}</b></div>
            </div>
            <div class="col-1 self-centered">
              <div class="btn btn-success" (click)="getPackage(p.packageId)"><i class="fas fa-plus"></i></div>
            </div>
          </div>
        </div>
        <div class="previewPackage" *ngIf="manage.packageType == 'own' && manage.data != null && !!manage.packageId && !!manage.package">
          <div class="row">
            <div class="col-9">
              <h2>#{{manage.package.packageNumber}} {{ manage.package.name }}</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-10" innerHTML="{{manage.package.description}}"></div>
            <div class="col-2">
              <img style="width:100%;height:100%;object-fit: contain;" class="previewPackage__img" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ manage.package.imageUrl }}" alt="Package Image">
            </div>
          </div>
          <h3>{{ 'OfferDetails.Materials' | translate }}</h3>
          <ul>
            <li *ngFor="let x of manage.package.customLines">{{x.quantity}}{{ ('OfferDetails.Pcs' | translate) | lowercase }} {{x.name | uppercase}}</li>
            <li *ngFor="let x of manage.package.productLines">{{x.quantity}}{{ ('OfferDetails.Pcs' | translate) | lowercase }} {{x.description | uppercase}}</li>
          </ul>
          <h3>{{'Booking.BookableHours' | translate}}</h3>
          <div>{{ manage.package.installationTimeInHours + ' ' + ('Standard.Hours' | translate) }}</div>
          <h3>{{ 'Package.Prerequisites' | translate }}</h3>
          <div innerHTML="{{ manage.package.disclaimer }}"></div>
          <h3>{{ 'Standard.TotalPrice' | translate }}</h3>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">{{ 'Standard.CostPrice' | translate }}: {{ ass.numsCurrency(manage.package.costPrice) }}</div>
            <div class="d-flex">{{ 'Standard.SalesPrice' | translate }}: {{ ass.numsCurrency(manage.package.salesPrice) }}</div>
            <div class="d-flex">{{ 'Standard.TotalInclVat' | translate }}: {{ ass.numsCurrency(manage.package.salesPrice + manage.package.salesVat) }}</div>
          </div>
        </div>
        <!--Library packages-->
        <div *ngIf="manage.packageType == 'library'">
          <app-library [mode]="'offer'" (selectPackage)="importPackageToOffer($event, true)"></app-library>
        </div>
        <button id="ClosePackageImporterModal" hidden #ClosePackageImporterModal data-dismiss="modal"></button>
      </div>
      <div class="modal-footer justify-content-between align-items-center" *ngIf="manage.packageId">
        <div>
          <button class="btn btn-sm btn-secondary"  data-target="#packageImporter" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
          <button class="btn btn-sm btn-primary" (click)="manage.packageId = null" >{{ 'Buttons.Back' | translate }}</button>
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center" *ngIf="!!groups">
            <button class="btn btn-sm btn-outline-secondary mr-2" (click)="manage.addGroup()" title="{{('Standard.AddGroup' | translate) + '\n'+ ('Groups.EmptyGroupsWillBeDeleted' | translate)}}"><i class="fas fa-folder-plus" style="font-size:1rem"></i></button>
            <select class="form-control form-control-sm" [ngModel]="selectedGroup" (change)="selectedGroupChange.emit($event.target.value)" *ngIf="groups.length > 0">
              <option [value]="null">{{ 'Standard.NoGroup' | translate }}</option>
              <option [value]="x.path" *ngFor="let x of groups">{{ x.description }}</option>
            </select>
          </div>
          <div class="d-flex align-items-center ml-2 mr-2" style="font-size:0.8rem;">
            {{ 'Standard.Description' | translate }}:
            <select class="form-control form-control-sm" [(ngModel)]="description">
              <option value="toDescription">{{ 'Import.AddToDescription' | translate }}</option>
              <option value="toProductLine">{{ 'Import.AddAsLine' | translate }}</option>
              <option value="ignore">{{ 'Import.Ignore' | translate }}</option>
            </select>
          </div>
          <button class="btn btn-sm btn-success" (click)="asGroup = true;importPackage()" data-target="#packageImporter" data-dismiss="modal">{{ 'Packages.ImportAsGroup' | translate }}</button>
          <button class="btn btn-sm btn-success" (click)="asMiscLine = true;importPackage()" data-target="#packageImporter" data-dismiss="modal">{{ 'Packages.ImportAsCustomLine' | translate }}</button>
          <button class="btn btn-sm btn-success" (click)="asMiscLine = false;importPackage()" data-target="#packageImporter" data-dismiss="modal">{{ 'Word.Import' | translate }}</button>
        </div>
      </div>
      <div class="modal-footer justify-content-start" *ngIf="!manage.packageId">
        <button class="btn btn-sm btn-secondary"  data-target="#packageImporter" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button class="btn btn-sm btn-primary" (click)="manage.packageType = 'library'" *ngIf="manage.packageType == 'own'" >{{ 'Packages.AddPackageFromLibrary' | translate }}</button>
        <button class="btn btn-sm btn-primary" (click)="manage.packageType = 'own'" *ngIf="manage.packageType == 'library'" >{{ 'Buttons.Back' | translate }}</button>
      </div>
    </div>
  </div>
</div>
